module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-231.0d87b5f5.svg";